import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { SectionHead, Reveal } from "./Reveal";
import { BookingForm } from "./BookingForm";

export const CONTACT = {
  phone: "+351 922 101 965",
  phoneHref: "tel:+351922101965",
  whatsapp: "https://wa.me/351922101965",
  email: "geral@turismodacapital.com",
  emailHref: "mailto:geral@turismodacapital.com",
  address: "Calçada de Santo André Nº 69, 1100‑496 Lisboa",
};

const Line = ({ icon: Icon, label, value, href, testid }) => (
  <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={testid}
    className="group flex items-center gap-5 border-t border-white/10 py-5 transition-colors hover:border-[#C5A059]/60">
    <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#C5A059]/40 text-[#E5C158] transition-[background-color,color] duration-300 group-hover:bg-[#C5A059] group-hover:text-black"><Icon size={17} /></span>
    <span>
      <span className="block text-[11px] uppercase tracking-[0.25em] text-zinc-400">{label}</span>
      <span className="block text-[#F9F9F9] mt-0.5">{value}</span>
    </span>
  </a>
);

export const Booking = () => {
  const { t } = useLang();
  return (
    <section id="reservar" className="relative py-28 md:py-40 bg-[#0A0A0C] overflow-hidden" data-testid="booking-section">
      <div className="pointer-events-none absolute -left-40 bottom-0 h-[520px] w-[520px] rounded-full bg-[#C5A059]/10 blur-[140px]" />
      <div className="relative mx-auto max-w-[1440px] px-5 md:px-10 grid lg:grid-cols-12 gap-14 lg:gap-16">
        <div className="lg:col-span-5" id="contactos">
          <SectionHead over={t.booking.over} lines={t.booking.title} sub={t.booking.sub} testid="booking-heading" />
          <Reveal delay={0.2} className="mt-14">
            <p className="font-display italic text-3xl text-[#F3E5AB] mb-6">{t.contact.title}</p>
            <Line icon={MessageCircle} label={t.contact.whatsapp} value={CONTACT.phone} href={CONTACT.whatsapp} testid="contact-whatsapp" />
            <Line icon={Phone} label={t.contact.call} value={CONTACT.phone} href={CONTACT.phoneHref} testid="contact-phone" />
            <Line icon={Mail} label={t.contact.email} value={CONTACT.email} href={CONTACT.emailHref} testid="contact-email" />
            <div className="flex items-center gap-5 border-y border-white/10 py-5" data-testid="contact-address">
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#C5A059]/40 text-[#E5C158]"><MapPin size={17} /></span>
              <span>
                <span className="block text-[11px] uppercase tracking-[0.25em] text-zinc-400">{t.contact.base}</span>
                <span className="block text-[#F9F9F9] mt-0.5">{CONTACT.address}</span>
              </span>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.1}><BookingForm /></Reveal>
        </div>
      </div>
    </section>
  );
};
